import { render, staticRenderFns } from "./platform_points_account_list.vue?vue&type=template&id=793ad8aa&scoped=true"
import script from "./platform_points_account_list.vue?vue&type=script&lang=js"
export * from "./platform_points_account_list.vue?vue&type=script&lang=js"
import style0 from "./platform_points_account_list.vue?vue&type=style&index=0&id=793ad8aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ad8aa",
  null
  
)

export default component.exports